import type { StoreApi } from "zustand";
import type { TChatStore } from "../chat-store.types";
import {
  webSocketInitialState,
  MAX_WEBSOCKET_TRIES,
} from "./connection.initial-state";

type TSetState = StoreApi<TChatStore>["setState"];

export const createConnectionActions = (set: TSetState) => ({
  setWebSocketLoading: () =>
    set((state) => {
      const tries =
        state.webSocket.tries === MAX_WEBSOCKET_TRIES
          ? MAX_WEBSOCKET_TRIES
          : state.webSocket.tries + 1;
      return {
        webSocket: {
          ...webSocketInitialState,
          loading: true,
          tries,
          idle: false,
        },
      };
    }),

  setWebSocketFulfilled: () =>
    set(() => ({
      webSocket: { ...webSocketInitialState, opened: true, idle: false },
    })),

  setWebSocketRejected: () =>
    set((state) => ({
      webSocket: {
        ...webSocketInitialState,
        error: true,
        tries: state.webSocket.tries,
        idle: false,
      },
    })),

  setWebSocketClosed: () =>
    set((state) => ({
      webSocket: {
        ...webSocketInitialState,
        closed: true,
        tries: state.webSocket.tries,
        idle: false,
      },
    })),
});
